import Controller from '@ember/controller';

export default class DashboardUrlSettingsCompetitorsController extends Controller {
  get url() {
    return this.model.url;
  }
}
